var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[(_vm.isMobile)?_c('TheHeaderMobile'):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"header__container"},[_c('TheHeaderTopbar',{attrs:{"display-type":'help'}}),_c('TheHeaderNavbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }